import Footer from './Footer.container';

export default Footer;
